// extracted by mini-css-extract-plugin
module.exports = {"main":"About_main__XcVKJ","heading":"About_heading__34MJ0","content":"About_content__1eItL","CV":"About_CV__2AZRD"};